export const ratingStyles: { [key: string]: string } = {
  good: 'bg-cons-green text-white',
  fair: 'bg-cons-yellow text-white',
  poor: 'bg-cons-yellow-step-down text-white',
  superior: 'bg-cons-blue-step-up text-white'
}
